import * as styles from './built-in-tag.css.ts'

/** Marks a tool Pixee provides itself, which needs no integration or import. */
export const BuiltInTag: React.FC = () => <span className={styles.builtInTag}>Built in</span>
